import React from 'react';
import { Route } from 'react-router-dom';

import { RoutePathProps } from '../../../AppRoutes/types';
import TodayIcon from '@mui/icons-material/Today';
import ListReminder from '../pages/ListReminder';
import ShowReminder from '../pages/ShowReminder';
import CreateEditReminder from '../pages/CreateEditReminder';


// import EditProduct from '../pages/EditProduct';

const reminder: RoutePathProps = {
  name: "reminder",
  path: "/reminder",
  label: "Reminders",
  icon: TodayIcon,
  visibleInNav: true,
  requiredPermission:'reminder:list',
  children: [
    {
      name: "showReminder",
      path: "/reminder/:id",
      label: "Show Reminder",
      icon: TodayIcon,
      requiredPermission:'reminder:read'
    },
    {
      name: "createReminder",
      path: "/reminder/createReminder",
      label: "Create Reminder",
      icon: TodayIcon,
      requiredPermission:'reminder:create'
    },
    {
      name: "editReminder",
      path: "/reminder/editReminder/:id",
      label: "Edit Reminder",
      icon: TodayIcon,
      requiredPermission:'reminder:update'
    },
    {
      name: "listReminder",
      path: "/reminder/listReminder",
      label: "List Reminder",
      icon: TodayIcon,
      requiredPermission:'reminder:list'
    }
  ],
};

const ReminderRoutes = (
  <>
    <Route path={reminder.path} element={<ListReminder />} />
    <Route path={reminder.children?.[0].path} element={<ShowReminder />} />
    <Route path={reminder.children?.[1].path} element={<CreateEditReminder />} />
    <Route path={reminder.children?.[2].path} element={<CreateEditReminder />} />
    {/* <Route path={reminder.children?.[2].path} element={<AddProduct />} /> */}
    <Route path={reminder.children?.[3].path} element={<ListReminder />} />

  </>
);
export const reminderPaths = [reminder];
export default ReminderRoutes;
